import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'ng-select';
import { BsDatepickerModule, TooltipModule } from 'ngx-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { BoxRetalStampsComponent } from './boxRetalStamps.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    TranslateModule,

  ],
  exports: [
    BoxRetalStampsComponent
  ],
  declarations: [BoxRetalStampsComponent]
})
export class BoxRetalStampsModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/boxRetalStamps/boxRetalStamps.module.ts